export default "Veille CEE, marché de l'énergie, aides à la rénovation et Décret Tertiaire — analyses documentées par l'équipe Solution Éco France. Articles experts, chiffres sourcés.";
